import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ICON_CANCEL, ICON_SELECT } from '../../extras/icons';
import { Button, Modal } from 'react-bootstrap';
import accusedData from '../../../data/accusedData';
import victimData from '../../../data/victimData';
//Función principal
const ProceedingParts = props => {
    //Tomo los props
    const { show, handleClose, proceeding, accuseds, setAccuseds, victims, setVictims, partType, editAccused, editVictim } = props;
    //Manejo la selección de la parte
    const handleSelectPart = part => {
        //Armo los nuevos datos
        const newData = {
            index: uuidv4(),
            persona: {
                apellido: part.apellido,
                nombre: part.nombre,
                tipo_documento: part.tipoDocumento,
                nro_documento: part.nroDocumento ? String(part.nroDocumento).replaceAll('.', '').replaceAll('-','').replaceAll('/','').replaceAll(' ', '').trim() : ''
            }
        }
        //Inicializo funciones
        let openForm;
        let formData;
        //Me fijo donde debo setearlo
        if(partType === 'accused'){
            //Armo la data
            const newAccusedData = {
                ...accusedData,
                ...newData
            }
            //Seteo datos
            setAccuseds([
                ...accuseds,
                {
                    ...newAccusedData
                }
            ])
            //Seteo la función
            openForm = editAccused;
            formData = newAccusedData;
        }
        //Victim
        if(partType === 'victim'){
            //Armo la data
            const newVictimData = {
                ...victimData,
                ...newData
            }
            //Seteo datos
            setVictims([
                ...victims,
                {
                    ...newVictimData
                }
            ])
            //Seteo la función
            openForm = editVictim;
            formData = newVictimData;
        }
        //Una vez seteado, cierro
        handleClose();
        //Tengo q abrir el formulario
        openForm(formData);
    }
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleClose} 
            //onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            scrollable
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Partes del Legajo: <strong>{ proceeding && proceeding.numero }</strong>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    proceeding ? (
                        <div className="row">
                            <div className="col-12">
                                <div className="alert alert-info">
                                    A continuación se muestran las <strong>partes</strong> del legajo <strong>{ proceeding.numero }</strong>. Seleccione el conveniente presionando el botón <ICON_SELECT />
                                </div>
                            </div>
                            <div className="col-12">
                                <table className="table table-striped table-hover table-sm">
                                    <thead className="thead-light">
                                        <tr>
                                            <th className="align-middle text-center">
                                                Datos de la parte
                                            </th>
                                            <th className="align-middle text-center">
                                                Sel.
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            proceeding.partes.map((parte, index) => (
                                                <tr key={`prp${index}`}>
                                                    <td className="align-middle">
                                                        <small>
                                                            { `${parte.apellido} ${parte.nombre} ${parte.tipoDocumento ? parte.tipoDocumento : ''} ${parte.nroDocumento ? parte.nroDocumento : ''}` }
                                                            <br/>
                                                            CARÁCTER: <strong>{ parte.caracter }</strong>
                                                        </small>
                                                    </td>
                                                    <td className="align-middle text-center">
                                                        <Button size="sm" variant="success" onClick={() => handleSelectPart(parte)}>
                                                            <ICON_SELECT />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : null
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <ICON_CANCEL /> Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ProceedingParts;